<script>

import styled from 'vue-styled-components'


const ContentFrame = styled.div`
  width: 799px;
  @media (max-width: 600px) {
    width: 100%;
  }
`

const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const PageTitle = styled.h1`
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
  line-height: 36px;
  padding-top: 6.2vh;
  margin-block-end: 12px; // hack?

  color: #000000;
`

const LessonCard = styled.div`
  // width: 90%;
  height: 191px;
  background: #FFFFFF;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.11);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 21px;
  margin-bottom: 12px;

  @media (max-width: 600px) {
    padding-left: 10px;
  }
`

const LessonCTA = styled.div`

  width: 118px;
  height: 35px;
  cursor: pointer; 

  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: #FFFFFF;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  background: #FF006B;
  border-radius: 3px;

  @media (max-width: 600px) {
    width: 69px;
    height: 27px;
  }

`

const QuestionTitle = styled.h1`
  font-family: 'Roboto', sans-serif;
  // padding-bottom: 69px;
  padding-bottom: 9vh;
  font-size: 36px;
  line-height: 108.7%;
  /* or 39px */
  text-align: center;
  color: #000000;
`
const QuestionWrapper =styled.div`
  //padding-top: 92px;
  padding-top: 12vh;
`
const ChoicesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10vw;
  padding-bottom: 14vh;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`
const Choice = styled('div', {selected: Boolean})`
  width: 25vw;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 90%;
  }

  height: 150px;

  padding-top: 34px;
  padding: 40px;
  margin: 10px;
  background: #FFFFFF;

  box-shadow: 0 3px 3px rgba(0,0,0,0.2);
  border: ${props => props.selected ? '7px solid #FF1074;' : 'none;'};

  display: flex;
  flex-direction: column;

  justify-content: space-between;

  text-align: center;
`

const ChoiceTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  line-height: 108.7%;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-weight: bold;
  color: #FF006B;
`
const ChoiceBlurb = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 21px;
  line-height: 108.7%;
  /* or 23px */
  color: #000000;
`
const ChoiceContext = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  line-height: 108.7%;
  /* or 17px */
  text-align: center;
  color: #444444;
`

const ChoiceConfirm = styled('div', { disabled: Boolean } )`

  width: 195px;
  height: 60px;
  cursor: pointer;

  background: ${props => props.disabled ? 'rgba(255, 0, 107, 0.2);' : '#FF006B'};

  border-radius: 3px;
  margin: 10px;

  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  line-height: 19px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15em;
  color: #FFFFFF;

  @media (max-width: 600px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: ${props => props.disabled ? '#FF006B' : '#FF006B'};
    margin: 0px;
  }
`


// 92 from top, 69 to bottom

const Selectable = styled.div`
  border: 1px solid white;
  padding: 10px;

`
// Create a <Wrapper> Vue component that renders a <section> with
// some padding and a papayawhip background
const Box = styled.section`
  padding: 4em;
  background: ${props => props.theme.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 60%;
  color: white;
`

const CTA = styled.button`
  background-color: #c3375b;
  color: white;
  padding: 20px;
  border-radius: 10px;
`
export default {
  components: {

    /* todo junk */
    'box' : Box,
    'cta' : CTA,
    'selectable': Selectable,
    /* end junk */

    'QuestionTitle' : QuestionTitle,
    'QuestionWrapper': QuestionWrapper,
    'ChoicesWrapper' : ChoicesWrapper,
    'Choice':  Choice,
    'ChoiceTitle' : ChoiceTitle,
    'ChoiceBlurb' : ChoiceBlurb,
    'ChoiceContext' : ChoiceContext,
    'ChoiceConfirm' : ChoiceConfirm,

    'PageTitle' : PageTitle,
    'CenterWrapper' : CenterWrapper,
    'ContentFrame' : ContentFrame,
    'LessonCard' : LessonCard,
    'LessonCTA':  LessonCTA
  }
}
</script>



// WEBPACK FOOTER //
// src/ui/UI.vue